import {clsx} from 'clsx';
import {isContainerQueryAvailable} from '../lib/container-query-with-fallback';
import styles from './description.module.css';

export function MediaUserLoginGuideDescription({...props}) {
  return (
    <p
      className={clsx(
        styles.description,
        isContainerQueryAvailable() ? styles.pressReleaseRoot : styles.screen,
      )}
      {...props}
    >
      <span>メディアユーザー登録を行うと、企業担当者の連絡先や、</span>
      <span>イベント・記者会見の情報など様々な特記情報を閲覧できます。</span>
      <span>※内容はプレスリリースにより異なります。</span>
    </p>
  );
}
